import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-tryout-required-custom-questions',
  templateUrl: './tryout-required-custom-questions.component.html',
  styleUrls: ['./tryout-required-custom-questions.component.css']
})
export class TryoutRequiredCustomQuestionsComponent implements OnInit {
  @Input() NoOfTotalRequiredQuestions: string;
  @Output() filterQuestionEvent = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

  filterQuestionListing(value) {
    this.filterQuestionEvent.emit(value);
  }

}



// WEBPACK FOOTER //
// ./src/app/tryout/components/tryout-required-custom-questions/tryout-required-custom-questions.component.ts